(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = definition();
    } else {
        RivalIQ.module('enums');
        RivalIQ.enums.token = definition();
    }

    function definition() {

        return {
            permission: {
                GRANTED: 'granted'
            }
        };
    }
})();
